import * as React from 'react';
import {
    FormControl,
    FormGroup,
    ControlLabel,
    Checkbox,
    HelpBlock,
    Row,
    Col
} from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import FormValidationService from '../../shared/form/FormValidationService';

interface IProductGroupFormProps {
    productGroup: any;
    onChange: (e: any) => void;
    onProductChange: (values: any) => void;
    products: any[];
    errors: any;
}

const ProductGroupForm = (props: IProductGroupFormProps) => {
    type IProductsInGroup = {
        id: number;
        name: string;
        checked: boolean;
    };

    let typedProducts = {};
    props.products.map((p: any) => {
        let isChecked = props.productGroup.products.includes(p.id);
        let curProduct: IProductsInGroup = {
            id: p.id,
            name: p.name,
            checked: isChecked
        };
        if (p.type && !typedProducts[p.type]) {
            typedProducts[p.type] = new Array(curProduct);
        } else {
            typedProducts[p.type].push(curProduct);
        }
    });

    return (
        <div>
            <FormGroup
                validationState={FormValidationService.getValidationState(props.errors.name)}
            >
                <ControlLabel>{Translate('product-groups/modal/input-label/name')}</ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="name"
                    value={props.productGroup ? props.productGroup.name : ''}
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors.name}</HelpBlock>
            </FormGroup>
            <p>
                <strong>{Translate('product-groups/modal/select-label/products')}</strong>
            </p>
            <Row>
                {Object.keys(typedProducts).map((k: any, i: number) => {
                    let curGroup = typedProducts[k];
                    return (
                        <Col sm={6} key={`product-type-${i}`}>
                            <fieldset>
                                <legend>{k}</legend>
                                {curGroup.map((p: any, j: number) => (
                                    <FormGroup key={`product-${j}`}>
                                        <Checkbox
                                            id={'products' + p.id}
                                            name="products"
                                            value={p.id}
                                            checked={p.checked}
                                            onChange={props.onProductChange}
                                        >
                                            <span>{p.name}</span>
                                        </Checkbox>
                                    </FormGroup>
                                ))}
                            </fieldset>
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
};

export default ProductGroupForm;
